import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getCalendarEntity } from '@constants/config';
import EventIcon from '@icons/event-icon';
import { Icon } from '@mui';
import DefaultDate from '@shared/formatted-date-helper';
import FlexSeparator from '@shared/helpers/flex-separator';
import { canEditEntities } from '@utils/permission-utils';
import './event-details-popup.scss';

const EventDetailsPopup = ({ selectedEvent, windowClose }) => {
  const editEvents = canEditEntities(null, getCalendarEntity());
  return (
    <div styleName={`popup-container ${editEvents ? '' : 'popup-container-read-only-events'}`}>
      <div styleName="row">
        <EventIcon />
        <span styleName="title">{selectedEvent.title}</span>
        <FlexSeparator />
        <Icon onClick={windowClose} role="img">
          close
        </Icon>
      </div>
      <div styleName="row">
        <div styleName="data-label">When</div>
        <DefaultDate value={selectedEvent.start} />
        <span> - </span>
        <DefaultDate value={selectedEvent.end} />
      </div>
      <div styleName="row">
        <div styleName="data-label">Where</div>
        <div>{selectedEvent.address}</div>
        <div styleName="view-on-map-link">
          <Link to={`/map?${getCalendarEntity()}=${selectedEvent.id}`}>
            <div styleName="view-on-map-label">
              <Icon onClick={windowClose} color="#0273CE" style={{ fontSize: '1rem' }} role="img">
                place
              </Icon>
              View on map
            </div>
          </Link>
        </div>
      </div>
      <div styleName="row">
        <div styleName="data-label">Created by</div><div>{selectedEvent.agency}</div>
      </div>
      <div styleName="row">
        <div styleName="data-label">Event type</div><div>{selectedEvent.typeName}</div>
      </div>
    </div>
  );
};

EventDetailsPopup.propTypes = {
  selectedEvent: PropTypes.object,
  windowClose: PropTypes.func
};

export default EventDetailsPopup;
